module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_photographer@3x-60e12527bcebaaf95c903cfe569ab786.webp";